import { ElegibleOrganizations } from 'modules/app/types/superAdmin';
import { RootState } from '../../../../config/store/rootReducer';

export const makeGetElegibleOrganizations = () => (state: RootState): ElegibleOrganizations | null =>
  state.organizations.globalInfo.elegibleOrganizations || null;
